import {z} from 'zod';

export const enqueueAdvertisementResponseSchema = z.object({
  jobId: z.string().uuid(),
});
